export default __webpack_public_path__ + "static/media/aa-logo-button.5d6419b0.png";